<template>
  <!-- 无人仓智控列表-->
  <div class="storeDevice">
    <div class="storeDevice__body box-shadow marginTop10 bcWhite padding10 flex1">
      <el-tabs v-model="tabs" @tab-click="handleTabClick">
        <el-tab-pane label="设备列表" name="1" />
        <el-tab-pane label="设备日志" name="2" />
      </el-tabs>
      <div v-if="tabs === '1'" class="wHP flex1">
        <el-row>
          <el-col :span="4">
            <el-input v-model="queryParams.storeRefName" style="width: 200px" placeholder="所属门店" clearable @keyup.enter.native="queryDeviceList"></el-input>
          </el-col>
          <el-col :span="4">
            <el-input v-model="queryParams.name" style="width: 200px" placeholder="设备名称" clearable @keyup.enter.native="queryDeviceList"></el-input>
          </el-col>
          <el-col :span="4">
            <el-input v-model="queryParams.customCode" style="width: 200px" placeholder="设备号" clearable @keyup.enter.native="queryDeviceList"></el-input>
          </el-col>
          <el-col :span="4">
            <el-input v-model="queryParams.code" style="width: 200px" placeholder="设备序列号" clearable @keyup.enter.native="queryDeviceList"></el-input>
          </el-col>
          <el-col :span="4">
            <el-select v-model="queryParams.type" placeholder="请选择" @change="queryDeviceList">
              <el-option label="疯狂物联" :value="10"></el-option>
              <el-option label="E控(SBox)" :value="20"></el-option>
              <el-option label="E控(主机)" :value="30"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <br /><br />
        <el-table ref="multipleTable" v-loading="tableLoading" max-height="500" border :data="tableData" tooltip-effect="dark" class="h650 scrollAuto scrollbar">
          <el-table-column label="所属门店" align="center" prop="storeRefName" />
          <el-table-column label="设备名称" align="center" prop="name" />
          <el-table-column label="设备号" align="center" prop="customCode" />
          <el-table-column label="设备序列号" align="code" prop="name" />
          <el-table-column prop="type" label="设备类型" align="center" width="100">
            <template #default="scope">
              {{ scope.row.type | getType }}
            </template>
          </el-table-column>
          <el-table-column prop="isValid" label="设备状态" align="center" width="80">
            <template #default="scope"> {{ scope.row.isValid === 1 ? "启用" : "停用" }}</template>
          </el-table-column>
          <el-table-column prop="isValid" label="设备网络状态" align="center" width="100">
            <template #default="scope"> {{ scope.row.status | getNetStatus }}</template>
          </el-table-column>

          <el-table-column prop="date" label="操作" align="center">
            <template #default="scope">
              <el-button v-if="scope.row.type !== '40'" size="mini" type="primary" @click="openTerminalForCrazy(scope.row)">终端控制</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page="queryPara.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="queryPara.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handlePageChange" />
      </div>
      <div v-if="tabs === '2'" class="wHP flex1">
        <el-row>
          <el-col :span="4">
            <el-input v-model="queryParams2.storeRefName" style="width: 200px" placeholder="所属门店" clearable @keyup.enter.native="queryLogList"></el-input>
          </el-col>
        </el-row>
        <el-table ref="list" v-loading="table2Loading" :data="logList">
          <el-table-column prop="storeRefName" label="所属门店" align="center" width="160"></el-table-column>
          <el-table-column prop="deviceRefName" label="设备名称" align="center" width="160"></el-table-column>
          <el-table-column prop="deviceCustomCode" label="设备号" align="center" width="90"></el-table-column>
          <el-table-column prop="type" label="设备类型" align="center" width="90">
            <template #default="scope">
              {{ scope.row.type | getType }}
            </template>
          </el-table-column>
          <el-table-column prop="response" label="返回数据Code" align="center"></el-table-column>
          <el-table-column prop="message" label="返回数据信息" align="center" width="220"></el-table-column>
          <el-table-column prop="status" label="请求状态" align="center" width="80">
            <template #default="scope">
              {{ scope.row.status | getStatus }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="操作时间" align="center" width="160"></el-table-column>
          <el-table-column prop="createRefName" label="操作人" align="center" width="120"></el-table-column>
          <el-table-column prop="remark" label="备注" align="center"></el-table-column>
        </el-table>
        <el-pagination :current-page="queryParams2.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams2.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total2" @size-change="handleSizeChange2" @current-change="handlePageChange2" />
      </div>
    </div>
    <el-dialog v-loading.fullscreen.lock="fullscreenLoading" title="终端列表" :visible.sync="terminalDialogVis" width="80%" append-to-body custom-class="terminalDialogContainer">
      <div class="openAddFlexColumn" style="background-color: white">
        <div class="openAddFlexColumn__bottom buttons">
          <el-button type="primary" @click="refreshTerminalStatusForEKongSBox"><i class="el-icon-refresh-right" />状态刷新</el-button>
        </div>
        <div class="openAddFlexColumn__body">
          <el-table ref="terminalListForSingle" :data="terminalList">
            <el-table-column prop="originName" label="指示灯" align="center" width="80">
              <template #default="scope">
                <i class="el-icon-sunny" :style="`color:${scope.row.status === 1 ? 'green' : 'red'};font-size:30px`"></i>
              </template>
            </el-table-column>
            <el-table-column prop="originName" label="终端名称" align="center"></el-table-column>
            <el-table-column prop="code" label="终端编号" align="center" width="80"></el-table-column>
            <el-table-column prop="name" label="终端自定义名称" align="center"></el-table-column>
            <el-table-column prop="type" label="类型" align="center">
              <template #default="scope">
                {{ scope.row.type === "10" ? "开关" : "场景" }}
              </template>
            </el-table-column>
            <el-table-column prop="permission" label="权限" align="center"></el-table-column>
            <el-table-column prop="status" label="终端状态" align="center">
              <template #default="scope">
                <el-switch v-if="scope.row.type == undefined || scope.row.type === '10'" v-model="scope.row.status" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" active-text="开启" inactive-text="关闭" @change="(value) => changeBySingle(scope.row, value)"> ></el-switch>
                <el-button v-if="scope.row.type === '20'" type="primary" size="mini" @click="changeBySingle(scope.row, 1)">点击</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment/moment";
export default {
  name: "StoreDevice",
  filters: {
    getType(type) {
      if (type === "10") return "疯狂物联";
      else if (type === "20") return "E控(SBox)";
      else if (type === "30") return "E控(主机)";
      else if (type === "40") return "乐橙";
      else return "未知设备";
    },
    getNetStatus(type) {
      if (type === 1) return "在线";
      else if (type === 0) return "离线";
      else return "未知状态";
    },
    getStatus(status) {
      if (status == 1) return "成功";
      else if (status == 0) return "失败";
      else "未知";
    },
  },
  data() {
    return {
      queryPara: {
        id: null,
        cname: null,
      },
      queryParams: {
        currentPage: 1,
        pageSize: 10,
      },
      queryParams2: {
        currentPage: 1,
        pageSize: 10,
        startDate: moment().startOf("day").format("YYYY-MM-DD"),
        endDate: moment().endOf("day").format("YYYY-MM-DD"),
      },
      terminalDialogVis: false,
      tableLoading: false,
      table2Loading: false,
      fullscreenLoading: false,
      total: 0,
      total2: 0,
      tableData: [],
      terminalList: [],
      logList: [],
      deviceInfo: null,
      tabs: "1",
    };
  },
  mounted() {
    this.queryDeviceList();
  },
  methods: {
    queryDeviceList() {
      this.tableLoading = true;
      this.topsAjax.get(`${this.baseUrls.iot}/queryDeviceList`, this.queryParams).then((response) => {
        this.total = response.total;
        this.tableData = response.list;
        this.tableLoading = false;
      });
    },
    queryLogList() {
      this.table2Loading = true;
      this.topsAjax.get(`${this.baseUrls.iot}/queryLogList`, this.queryParams2).then((response) => {
        this.total2 = response.total;
        this.logList = response.list;
        this.table2Loading = false;
      });
    },
    openTerminalForCrazy(row) {
      this.deviceInfo = row;
      this.topsAjax.get(`${this.baseUrls.iot}/queryTerminalList`, { deviceId: row.sid, code: row.code, type: row.type }).then((response) => {
        let arr = [];
        for (let i = 0; i < response.length; i++) {
          if (response[i].permission === "1") {
            response[i].deviceType = this.deviceInfo.type;
            arr.push(response[i]);
          }
        }
        this.terminalList = arr;
        this.terminalDialogVis = true;
      });
    },
    refreshTerminalStatusForEKongSBox() {
      this.deviceRefreshLoading = true;
      let url = `${this.baseUrls.iot}/uploadData`;
      this.topsAjax.get(url, { devUid: this.deviceInfo.code, type: this.deviceInfo.type }).then(() => {
        this.deviceRefreshLoading = false;
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.topsAjax.get(`${this.baseUrls.iot}/queryTerminalList`, { deviceId: this.deviceInfo.sid, code: this.deviceInfo.code, type: this.deviceInfo.type }).then((response) => {
          let arr = [];
          for (let i = 0; i < response.length; i++) {
            if (response[i].permission === "1") {
              arr.push(response[i]);
            }
          }
          this.terminalList = arr;
        });
      });
    },
    changeBySingle(row, type) {
      row.openOrclose = type == 1 ? true : false;
      row.deviceType = this.deviceInfo.type;
      let url = `${this.baseUrls.iot}/openOrCloseTerminal`;
      this.topsAjax.post(url, row).then(() => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    handleTabClick(tab, event) {
      if (tab.index === "0") {
        this.queryDeviceList();
      } else {
        this.queryLogList();
      }
    },
    handlePageChange(currentPage) {
      this.queryParams.currentPage = currentPage;
      this.queryDeviceList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.queryDeviceList();
    },
    handlePageChange2(currentPage) {
      this.queryParams2.currentPage = currentPage;
      this.queryDeviceList();
    },
    handleSizeChange2(val) {
      this.queryParams2.pageSize = val;
      this.queryDeviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.storeDevice {
  padding: 5px;
  height: 100%;
  display: flex;
  width: 100%;
  flex-direction: column;
  flex: 1;

  &__body {
    overflow: auto;
    height: 100%;
    background-color: white;
  }
}

.green {
  background-color: #60e722;
}

.gray {
  background-color: gray;
}

.center {
  display: flex;
  justify-content: center;
}

.circle {
  width: 25px; /* 圆的直径 */
  height: 25px; /* 圆的直径 */
  border-radius: 50%; /* 使元素成为圆形的关键属性 */
}
</style>
